export const error = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  marginTop: 300,
  marginBottom: 300,
  width: '100%',
}
